export default {
  hordeEnergyToStr: '每点当前能量提供+{0}力量',
  hordeEnergyToEnergyReg: '每点缺失能量提供+{0}能量恢复',
  hordeEnergyOnCrit: '暴击时获得{0}点能量',
  hordeHealOnCrit: '暴击时恢复最大生命值的{0}',
  hordeRestoreCooldownOnCrit: '暴击时减少技能冷却时间{0}',
  hordeBloodOnCrit: '暴击时获得{0}点敌人之血',
  hordeManaRest: '{0}秒不使用主动技能后，获得{1}点法力恢复',
  hordeManasteal: '击杀敌人时获得{0}点法力',
  hordePassiveRecovery: '每秒自动恢复{0}点生命',
  hordeActiveDamageCrit: '伤害类主动技能可以以{0}的效率暴击',
  hordeActiveHealCrit: '治疗类主动技能可以以{0}的效率暴击',
  hordeAttackAfterTime: '在同一场战斗中每分钟获得+{0}攻击力',
  hordeStrIntAfterTime: '在同一战斗中每分钟获得{0}力量和智力',
}